export default __webpack_public_path__ + "static/reaction-marketing-1f2ec620953e87337e50d31ea4d0319c.png";